<template lang="pug">
#app(v-if="$auth.ready()")
  el-menu#nav(v-if="$auth.check()", default-active="1", mode="horizontal", :router="true")
    el-menu-item(index="dashboard", v-if="$auth.check(['admin', 'dashboard'])", :route="{path: '/dashboard'}") Dental Tribune
    el-menu-item(index="payments", v-if="$auth.check(['admin', 'payments'])", :route="{path: '/payments'}") Паричен поток
    el-menu-item(index="contragents", v-if="$auth.check(['admin', 'contragents'])", :route="{path: '/contragents'}") Контрагенти
    el-menu-item(index="reports", v-if="$auth.check(['admin', 'reports'])", :route="{path: '/reports'}") Отчети

    el-submenu(index="others-submenu")
      template(slot="title") Други
      el-menu-item(index="literature", v-if="$auth.check(['admin', 'literature'])", :route="{path: '/literature'}") Литература
      el-menu-item(index="events", v-if="$auth.check(['admin', 'events'])", :route="{path: '/events'}") Събития
      el-menu-item(index="labels", v-if="$auth.check(['admin', 'labels'])", :route="{path: '/labels'}") Етикети

    el-submenu(index="right-submenu", style="float: right")
      template(slot="title") Здравей, {{ $auth.user().name }}
      el-menu-item(index="users", v-if="$auth.check(['admin', 'users'])", :route="{path: '/users'}") Администратори
      el-menu-item(index="profile", :route="{path: '/users/' + $auth.user().id}") Профил
      el-menu-item(index="logout", @click.native="logout") Излез

  keep-alive(include="PaymentList,ContragentList,LiteratureList,EventList,UserList,Labels")
    //- transition(name="fade", mode="out-in", appear)
    router-view


</template>

<script>

export default {
  name: 'app',
  methods: {
    logout () {
      this.$auth.logout({
        makeRequest: false,
        redirect: '/login'
      })
    }
  },
  // watch: {
  //   $route () {
  //     console.log('in app change')
  //   }
  // }
}
</script>

<style lang="stylus">
body
  padding 80px 20px 20px 20px
  margin 0
  font-family Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
a
  color: #4078c0;
  text-decoration: none;
h1, h2
  font-weight normal

// Overwrite the default "monospace" font (UserAgent in Chrome) to be
// consistent with <input />.
textarea
  font-family: inherit;

.cf:after
  content ""
  display block
  clear both
.fl
  float left
.fr
  float right
.tl, tl input
  text-align left
.tr, .tr input
  text-align right
.tc, tc input
  text-align center
h2
  margin 10px 0
  .el-button
    margin-left 20px
  .el-dropdown
    vertical-align middle
.el-col
  padding-left 10px
  padding-right 10px
  min-height 1px
.el-input, .el-select, .el-autocomplete, .el-date-editor.el-input
  width 100%

.el-table td
  padding 7px 0
.el-table .cell, .el-table th>div
  padding-left 10px
  padding-right 10px
.el-pagination
  padding 10px 0


.el-form-item__content, .el-form-item__label
  line-height 20px !important
.el-form--label-top .el-form-item__label
  font-size 12px
  padding-bottom 5px
.el-input-group__append, .el-input-group__prepend
  padding 0 10px

.el-card__header
  // background #E5E9F2
  h2
    margin 0
.form-actions
  position relative
  margin 0 -20px -10px -20px
  padding 10px 30px 0 30px
  border-top 1px solid #D3DCE6
  button
    display block
  // background red
#app
  //

#nav
  z-index 1000
  position absolute
  top 0
  left 0
  right 0

.well
  padding 18px 24px
  background-color #f9fafc
  border 1px solid #eaeefb
  margin-bottom 25px
  border-radius 4px


// PAYMENTS
.subjects-column .cell
  white-space nowrap
  overflow hidden
  word-break break-all
  text-overflow ellipsis
.text-success
  color #13ce66
  color #0c8040
  color #284c17
.text-danger
  color #ff4949
  color #d10000
  color #5a0000
.document-column
  overflow visible
.icon-overdue
  margin-left 5px
  color #ff4949
  // position absolute
  // left -10px



.slide-enter-active, .slide-enter
  transition all .2s ease

.slide-enter, .slide-leave-to
  opacity 0

.slide-enter
  transform translateX(-3rem)

.slide-leave, .slide-leave-active
  transition all .25s ease

.slide-leave-to
  transform translateX(3rem)


.fade-enter-active, .fade-leave-active
  transition opacity .2s
.fade-enter, .fade-leave-to
  opacity 0
</style>
